import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadConfigurationService from '../../services/LoadConfigurationService';
import {
  changeRoom,
  initializeSections,
  initializeSummaryCameras,
  setApplicationState,
  setPromotionSlug,
} from '../../model/configuratorSlice';
import { ApplicationState } from '../../model/constants';
import MainLoader from '../Loader/MainLoader';
import Configurator from './Configurator';
import IsNullOrUndefined from '../../utils/ObjectUtils';
import UserStatusPopup from '../User/UserStatusPopup';
import LoginService from '../../services/LoginService';
import LoadConfigurationUnitService from '../../services/LoadConfigurationUnitService';

const ConfiguratorGuard = () => {
  const {
    promotionCode, unitCode, code, promotionSlug,
  } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { applicationState, rooms } = useSelector(state => state.configurator);
  const loginMutation = LoginService();
  const loadConfigurationMutation = LoadConfigurationService();
  const loadConfigurationUnitMutation = LoadConfigurationUnitService();

  const dispatch = useDispatch();

  useEffect(() => {
    const payload = {};
    const token = searchParams.get('token');

    if (!IsNullOrUndefined(promotionCode) && !IsNullOrUndefined(unitCode)
      && !IsNullOrUndefined(token)) {
      payload.promotion_code = promotionCode;
      payload.unit_code = unitCode;
      payload.token = encodeURIComponent(token);
      loginMutation.mutate(payload);
      dispatch(setApplicationState(ApplicationState.UserLoggedOut));
    } else {
      dispatch(setPromotionSlug(promotionSlug));
      dispatch(setApplicationState(ApplicationState.NotInitialized));
    }

    // setSearchParams();
  }, []);

  useEffect(() => {
    console.log(`applicationState: ${applicationState}`);
    switch (applicationState) {
      case ApplicationState.NotInitialized:
        loadConfigurationMutation.mutate({});
        break;
      case ApplicationState.UserLoggedIn:
        loadConfigurationUnitMutation.mutate({});
        break;
      case ApplicationState.PromotionLoaded:
        dispatch(changeRoom(rooms[0].id));
        dispatch(initializeSections());
        dispatch(initializeSummaryCameras());
        break;
      default:
        break;
    }
  }, [applicationState]);

  switch (applicationState) {
    case ApplicationState.NotInitialized:
      return <MainLoader />;
    case ApplicationState.UserLoginFailed:
      return <UserStatusPopup />;
    case ApplicationState.UserLoggedIn:
      return <MainLoader />;
    case ApplicationState.PromotionLoaded:
      return <Configurator />;
    case ApplicationState.Ready:
      return <Configurator />;
    default:
      return <MainLoader />;
  }
};

export default ConfiguratorGuard;
